import { post } from "../helpers/config";
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export type PendingAiAgentAction = {
    actionId: string;
    toolName: string;
    summary: string;
};

export type AiAgentChatResponse = {
    conversationId: string;
    reply: string;
    pendingActions: PendingAiAgentAction[];
};

export const useAiAgentChat = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: { conversationId?: string | null; message: string }) => {
        return await post("aiagent/chat", data);
    }, options);
};

export const useConfirmAiAgentAction = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: { actionId: string }) => {
        return await post(`aiagent/actions/${data.actionId}/confirm`, {});
    }, options);
};

export const useCancelAiAgentAction = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: { actionId: string }) => {
        return await post(`aiagent/actions/${data.actionId}/cancel`, {});
    }, options);
};
